import { memo } from 'react';
import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import { useSelector } from '@bonanza-social/toolkit/state';
import { isUserOnBreak } from '@bonanza-social/account';

function DailyGiftLockedBottomSheet({ close }: BottomSheetExtendedProps) {
  const isUserTimedOut = useSelector(isUserOnBreak);

  return (
    <Box flexDirection="column" gap="space-400">
      <Image
        name="common.BonanzaCoinStack"
        width={64}
        height={64}
        alignSelf="center"
      />
      <Text
        variant="h4"
        color="darkSurfacePrimary"
        locNS="dailyGift"
        locKey="widgetLabel"
        textAlign="center"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="dailyGift"
        locKey="coinsDescription"
        textAlign="center"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="dailyGift"
        locKey={isUserTimedOut ? 'lockedMessageTimeout' : 'lockedMessage'}
        textAlign="center"
      />
      <Button
        variant="secondary"
        locNS={isUserTimedOut ? 'common' : 'dailyGift'}
        locKey={isUserTimedOut ? 'cancel' : 'maybeLaterCta'}
        onPress={close}
      />
    </Box>
  );
}

export default memo(DailyGiftLockedBottomSheet);
